import { useTrackEventEffect } from '@order/Telemetry';

import { useIsLoggedIn } from '../../../../context/AuthMachine';
import { useGiftCardOrdersQuery } from '../../graphql/GiftCardOrders.generated';

export const useGiftCardOrders = () => {
  const isLoggedIn = useIsLoggedIn();

  const [{ data, fetching, error }] = useGiftCardOrdersQuery({
    pause: !isLoggedIn,
    requestPolicy: 'network-only',
  });

  const giftCardOrders = data?.giftCardPurchaseHistory?.giftCardOrders ?? [];

  useTrackEventEffect({
    name: 'gift.history_failure',
    skip: !error,
    payload: {
      userError: error?.message,
      systemError: error,
    },
  });

  return {
    giftCardOrders,
    isFetchingOrders: fetching,
  };
};
